import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
//import ImageUploader from 'react-images-upload';
import DatePicker from "react-datepicker";

import { useFormik } from 'formik';
import * as Yup from 'yup';

import { States } from '../../helpers/constants';

import { mainviewActions, modalActions, MAPBOX_GEOCODE_URL } from '../../helpers/constants';

import { setSidebarItem } from '../../actions/sidebar/sidebar';
import { hideModal } from '../../actions/modal/modal';
import { updateKoalaSighting } from '../../actions/mainview/mainview';

const EditSightingForm = () => {

  const dispatch = useDispatch(),
        appProps = useSelector(store => store.app),
        mainviewProps = useSelector(store => store.mainview),
        formik = useFormik({
          initialValues: {
            datetime_of_sighting: new Date(mainviewProps.editedKoalaSighting.datetime_of_sighting),
            location: mainviewProps.editedKoalaSighting.location,
            status: mainviewProps.editedKoalaSighting.status,
            sex: mainviewProps.editedKoalaSighting.sex,
            with_joey: mainviewProps.editedKoalaSighting.with_joey,
            tree_species: mainviewProps.editedKoalaSighting.tree_species,
            photo: mainviewProps.editedKoalaSighting.photo,
            verified: mainviewProps.editedKoalaSighting.verified,
            first_name: mainviewProps.editedKoalaSighting.first_name,
            surname: mainviewProps.editedKoalaSighting.surname,
            phone: mainviewProps.editedKoalaSighting.phone === null ? '' : mainviewProps.editedKoalaSighting.phone,
            email: mainviewProps.editedKoalaSighting.email,
            postal_address: mainviewProps.editedKoalaSighting.postal_address,
            postal_suburb: mainviewProps.editedKoalaSighting.postal_suburb,
            postal_state: mainviewProps.editedKoalaSighting.postal_state,
            postal_code: mainviewProps.editedKoalaSighting.postal_code === null ? '' : mainviewProps.editedKoalaSighting.postal_code,
            group_name: mainviewProps.editedKoalaSighting.group_name,
            more_information: mainviewProps.editedKoalaSighting.more_information,
            video_url: mainviewProps.editedKoalaSighting.video_url,
            latitude: mainviewProps.editedKoalaSighting.latitude,
            longitude: mainviewProps.editedKoalaSighting.longitude
          },
          validationSchema: Yup.object({
            postal_code: Yup.string().matches(/^\d+$/, 'Postal code can only contain numbers')
          }),
          onSubmit: values => {

            let form = new FormData();

            // Check each field to see if something has changed
            if (formik.initialValues.datetime_of_sighting !== values.datetime_of_sighting) form.append('datetime_of_sighting', values.datetime_of_sighting.toISOString());
            if (formik.initialValues.status !== values.status) form.append('status', values.status);
            if (formik.initialValues.sex !== values.sex) form.append('sex', values.sex);
            if (formik.initialValues.more_information !== values.more_information) form.append('more_information', values.more_information);
            if (formik.initialValues.tree_species !== values.tree_species) form.append('tree_species', values.tree_species);

            if (formik.initialValues.email !== values.email) form.append('email', values.email);
            if (formik.initialValues.first_name !== values.first_name) form.append('first_name', values.first_name);
            if (formik.initialValues.surname !== values.surname) form.append('surname', values.surname);
            if (formik.initialValues.phone !== values.phone) form.append('phone', values.phone);
            if (formik.initialValues.postal_address !== values.postal_address) form.append('postal_address', values.postal_address);
            if (formik.initialValues.postal_code !== values.postal_code) form.append('postal_code', values.postal_code);
            if (formik.initialValues.postal_suburb !== values.postal_suburb) form.append('postal_suburb', values.postal_suburb);
            if (formik.initialValues.postal_state !== values.postal_state) form.append('postal_state', values.postal_state);
            if (formik.initialValues.group_name !== values.group_name) form.append('group_name', values.group_name);

            if (formik.initialValues.video_url !== values.video_url) form.append('video_url', values.video_url);

            if (formik.initialValues.latitude !== values.latitude) form.append('latitude', values.latitude);
            if (formik.initialValues.longitude !== values.longitude) form.append('longitude', values.longitude);
            if (formik.initialValues.location !== values.location) form.append('location', values.location);

            //if (formik.initialValues.with_joey !== values.with_joey) form.append('with_joey', values.with_joey);
            //if (formik.initialValues.verified !== values.verified) form.append('verified', values.verified);
            form.append('with_joey', values.with_joey); // with joey and verified must be sent no matter what
            form.append('verified', values.verified);

            dispatch(updateKoalaSighting(form, mainviewProps.editedKoalaSighting.id));
          }
        }),
        isAdmin = appProps.loggedInUser?.is_admin;

  const _modalClose = () => {
    if (formik.dirty)
      if (!window.confirm('You have unsaved changes. Closing will lose any changes.\nAre you sure you wish to close?')) return false;

    dispatch({ type: mainviewActions.EDIT_KOALA_SIGHTING_CANCEL });
    dispatch(hideModal());

    _cancelClickedLocation();
  }

  const _selectLocationOnMap = () => {
    dispatch(setSidebarItem('')); // Hide sidebar ready to intercept any clicks to take them away from continuing sighting location selection flow.

    dispatch({ type: mainviewActions.SELECT_LOCATION_ON_MAP });
    dispatch({
      type: modalActions.SUSPEND_MODAL,
      payload: true
    });
  }

  const _cancelClickedLocation = () => {

    dispatch({ type: mainviewActions.SELECT_LOCATION_ON_MAP_CANCEL }); // Remove previously clicked location

  }

  const _reverseGeocode = async (lat, lng) => {

    const reqUrl = `${ MAPBOX_GEOCODE_URL }/${ lng },${ lat }.json?access_token=${ process.env.REACT_APP_Mapbox_API_Key }&country=au`;

    let response = await fetch(reqUrl);
    let json = await response.json();

    return json.features[0]?.place_name;
  }

  useEffect(() => {
    if (mainviewProps.chosenLocation === null) return;

    formik.setFieldValue('latitude', mainviewProps.chosenLocation.lat);
    formik.setFieldValue('longitude', mainviewProps.chosenLocation.lng);

    _reverseGeocode(mainviewProps.chosenLocation.lat, mainviewProps.chosenLocation.lng)
    .then(placeName => {
      formik.setFieldValue('location', placeName);
    });

    formik.errors = {};
  }, [mainviewProps.chosenLocation]);

  return (
    <>
      <span className="modal__close" onClick={ () => _modalClose() }>&times;</span>
      
      <form className="form form--restricted" onSubmit={ formik.handleSubmit }>

        <div className="form__group">
          <label className="form__label">Koala sighting location</label>
          <p className="form__text" style={{ fontSize: '1rem', margin: '.2rem 0 .5rem .2rem' }}>{ formik.values.location }</p>
          <p className="form__help-text" style={{ margin: '0 0 .2rem .2rem', fontSize: '.7rem', textAlign: 'left' }}>Want to move this sighting to a new location on the map? <span onClick={ () => _selectLocationOnMap() } className="form__help-link" title="Select a location on the map.">Choose here</span>.</p>
        </div>

        <div className="form__group">
          <label htmlFor="datetime_of_sighting" className="form__label">Sighting date</label>
          <DatePicker
            selected={ formik.values.datetime_of_sighting }
            showTimeSelect
            className="form__input"
            name="datetime_of_sighting"
            id="datetime_of_sighting"
            dateFormat="d/M/yyyy, h:mm aa"
            timeIntervals={ 15 }
            onChange={ date => formik.setFieldValue('datetime_of_sighting', date) } />
        </div>

        <div className="form__group">
          <label htmlFor="sex" className="form__label">Koala's sex</label>
          <div className="form__select-container">
            <select className="form__select" id="sex" value={ formik.values.sex } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="sex">
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Unknown">Not sure</option>
            </select>
          </div>
        </div>

        <div className="form__group">
          <label htmlFor="status" className="form__label">Koala status</label>
          <div className="form__select-container">
            <select className="form__select" id="status" value={ formik.values.status } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="status">
              <option value="Healthy">Healthy</option>
              <option value="Sick/Injured">Sick/Injured</option>
              <option value="Deceased">Deceased</option>
            </select>
          </div>
        </div>

        <div className="form__group">
          <label htmlFor="with_joey" className="form__label">With a Joey?</label>
          <div className="form__select-container">
            <select className="form__select" id="with_joey" value={ formik.values.with_joey } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="with_joey">
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
          </div>
        </div>

        {
          isAdmin ?
          (
            <>
              <div className="form__group">
                <label htmlFor="verified" className="form__label">Verified sighting?</label>
                <div className="form__select-container">
                  <select className="form__select" id="verified" value={ formik.values.verified } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="verified">
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              </div>

              <div className="form__group">
                <label htmlFor="tree_species" className="form__label">Tree species</label>
                <input type="text" placeholder="Tree species" name="tree_species" value={ formik.values.tree_species } onChange={ formik.handleChange } onBlur={ formik.handleBlur } id="tree_species" className="form__input" />
              </div>

              <div className="form__group">
                <label htmlFor="video_url" className="form__label">Koala video URL</label>
                <input type="text" placeholder="Video url" name="video_url" value={ formik.values.video_url } onChange={ formik.handleChange } onBlur={ formik.handleBlur } id="video_url" className="form__input" />
              </div>
              
              <div className="form__group">
                <label htmlFor="more_information" className="form__label">More information</label>
                <textarea type="text" placeholder="More information&hellip;" value={ formik.values.more_information } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="more_information" id="more_information" className="form__input form__input--text-area"></textarea>
              </div>

              <div className="form__group">
                <label className="form__label">Observer information</label>
                <input className="form__input" type="text" value={ formik.values.first_name } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="first_name" id="first_name" placeholder="First name" />
                <input className="form__input" type="text" value={ formik.values.surname } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="surname" id="surname" placeholder="Surname" />
                <input className="form__input" type="tel" value={ formik.values.phone } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="phone" id="phone" placeholder="Phone number" />
                <input className="form__input" type="text" value={ formik.values.postal_address } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="postal_address" id="postal_address" placeholder="Address" />
                <input className="form__input" type="text" value={ formik.values.postal_code } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="postal_code" id="postal_code" placeholder="Postal code" />
                { formik.touched.postal_code && formik.errors.postal_code ? (<span className="form__error-item">{ formik.errors.postal_code }</span>) : ''}
                <input className="form__input" type="text" value={ formik.values.postal_suburb } onChange={ formik.handleChange } onBlur={ formik.handleBlur } name="postal_suburb" id="postal_suburb" placeholder="Suburb" />
                
                <div className="form__select-container">
                  <select className="form__select" onChange={ formik.handleChange } value={ formik.values.postal_state } onBlur={ formik.handleBlur } name="postal_state" id="postal_state">
                    {
                      Object.values(States).map((state, key) => (
                        <option value={ state } key={ key }>{ state }</option>
                      ))
                    }
                  </select>
                </div>
              </div>
            </>
          ) : null
        }
              
        <div className="form__button-group">
          <span className="form__button button button--hollow" onClick={ () => _modalClose(true) }>Cancel</span>
          <button type="submit" className="form__button button" disabled={ appProps.loading || !formik.dirty }>Update sighting</button>
        </div>

      </form>
    </>
  );

}

export default EditSightingForm;